export const GET_DIALER_SETTINGS = 'GET_DIALER_SETTINGS';
export const GET_DIALER_PROFILE = 'GET_DIALER_PROFILE';
export const GET_ALL_DIALER_PROFILES = 'GET_ALL_DIALER_PROFILES';



// WEBPACK FOOTER //
// ./src/constants/dialer.js